"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDateRangeV2Store = void 0;
var mobx_1 = require("mobx");
var moment_1 = __importDefault(require("moment"));
var CustomDateRangeV2Store = (function () {
    function CustomDateRangeV2Store(onChangeShortcut) {
        var _this = this;
        this.range = [null, null];
        this.isChangedByDayPicker = false;
        this.shortcuts = [];
        this.componentRef = null;
        this.setComponentRef = function (ref) {
            _this.componentRef = ref;
        };
        this.setShortcuts = function (value) {
            _this.shortcuts = value;
        };
        this.setRange = function (value) {
            var _a;
            (_a = _this.shortcuts) === null || _a === void 0 ? void 0 : _a.some(function (sh, index) {
                var _a;
                var result = areEqualsDateRanges(sh === null || sh === void 0 ? void 0 : sh.dateRange, value);
                if (result) {
                    (_a = _this.componentRef) === null || _a === void 0 ? void 0 : _a.setState({
                        selectedShortcutIndex: index
                    });
                }
                return result;
            });
            _this.range = value;
        };
        this.setIsChangedByDayPicker = function (value) { return function () {
            _this.isChangedByDayPicker = value;
        }; };
        this.formatDate = function (format) { return function (date) {
            var _a, _b, _c, _d, _e, _f;
            var isStartDate = ((_b = (_a = _this.componentRef) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.boundaryToModify) === 'start';
            var dateFormValue = isStartDate ? (_c = _this.range) === null || _c === void 0 ? void 0 : _c[0] : (_d = _this.range) === null || _d === void 0 ? void 0 : _d[1];
            var formatValue = dateFormValue
                ? (_e = (0, moment_1.default)(dateFormValue)) === null || _e === void 0 ? void 0 : _e.format('hh:mm a')
                : '12:00 am';
            if (formatValue === '12:00 am' && !isStartDate) {
                formatValue = '11:59 pm';
            }
            var finalDate = (0, moment_1.default)("".concat((_f = (0, moment_1.default)(date)) === null || _f === void 0 ? void 0 : _f.format('MM/DD/YYYY'), " ").concat(formatValue));
            return (0, moment_1.default)(finalDate).format(format);
        }; };
        this.handleOnChange = function (fieldState, onChange, defaultEndTimeWithEndDay) { return function (val) {
            var _a, _b, _c;
            _this.removePopoverDismiss();
            console.log(val);
            if (defaultEndTimeWithEndDay &&
                _this.isChangedByDayPicker &&
                val[1] &&
                (0, moment_1.default)(val[1]).format('hh:mm a') === '12:00 am') {
                val[1] = (0, moment_1.default)("".concat((0, moment_1.default)(val[1]).format('MM/DD/YYYY'), " 11:59 pm")).toDate();
            }
            fieldState === null || fieldState === void 0 ? void 0 : fieldState.onChange(val);
            onChange === null || onChange === void 0 ? void 0 : onChange(val);
            (_c = (_b = (_a = _this.componentRef) === null || _a === void 0 ? void 0 : _a.startInputElement) === null || _b === void 0 ? void 0 : _b.setAttribute) === null || _c === void 0 ? void 0 : _c.call(_b, 'value', 'esto es la polla chaval');
            _this.setRange(val);
        }; };
        this.removePopoverDismiss = function () {
            var shortcuts = document.querySelectorAll('.bp3-daterangepicker-shortcuts li .bp3-menu-item');
            shortcuts.forEach(function (shortcut) {
                shortcut.classList.remove('bp3-popover-dismiss');
                shortcut.addEventListener('click', _this.handleChangeShortcut((shortcut === null || shortcut === void 0 ? void 0 : shortcut.textContent) || ''));
            });
        };
        this.handleChangeFromExterior = function (value, format) {
            if (value === void 0) { value = [null, null]; }
            if (format === void 0) { format = 'MM/DD/YYYY'; }
            if (!areEqualsDateRanges(value, _this.range, format)) {
                _this.setRange(value);
            }
        };
        this.handleChangeShortcut = function (text) { return function () {
            var _a;
            if (text) {
                var shortcut = (_a = _this.shortcuts) === null || _a === void 0 ? void 0 : _a.find(function (sh) { return sh.label === text; });
                if (shortcut && _this.onChangeShortcut) {
                    _this.onChangeShortcut(shortcut);
                }
            }
        }; };
        this.onChangeShortcut = onChangeShortcut;
    }
    __decorate([
        mobx_1.observable
    ], CustomDateRangeV2Store.prototype, "range", void 0);
    __decorate([
        mobx_1.observable
    ], CustomDateRangeV2Store.prototype, "isChangedByDayPicker", void 0);
    __decorate([
        mobx_1.observable
    ], CustomDateRangeV2Store.prototype, "shortcuts", void 0);
    __decorate([
        mobx_1.observable
    ], CustomDateRangeV2Store.prototype, "onChangeShortcut", void 0);
    __decorate([
        mobx_1.observable
    ], CustomDateRangeV2Store.prototype, "componentRef", void 0);
    __decorate([
        mobx_1.action
    ], CustomDateRangeV2Store.prototype, "setComponentRef", void 0);
    __decorate([
        mobx_1.action
    ], CustomDateRangeV2Store.prototype, "setShortcuts", void 0);
    __decorate([
        mobx_1.action
    ], CustomDateRangeV2Store.prototype, "setRange", void 0);
    __decorate([
        mobx_1.action
    ], CustomDateRangeV2Store.prototype, "setIsChangedByDayPicker", void 0);
    return CustomDateRangeV2Store;
}());
exports.CustomDateRangeV2Store = CustomDateRangeV2Store;
var areEqualsDateRanges = function (range1, range2, format) {
    if (format === void 0) { format = 'MM/DD/YYYY'; }
    if (!range1.some(function (date) { return date; }) && !range2.some(function (date) { return date; })) {
        return true;
    }
    if (!range1[0] || !range2[0]) {
        return false;
    }
    if (!range1[1] || !range2[1]) {
        return false;
    }
    return ((0, moment_1.default)(range1[0]).format(format) === (0, moment_1.default)(range2[0]).format(format) &&
        (0, moment_1.default)(range1[1]).format(format) === (0, moment_1.default)(range2[1]).format(format));
};
